// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown__item[data-v-d51f08a6] {\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
